<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps({
  authenticatedUser: { type: Boolean, required: true },
});

const infoMessage = computed(() => {
  if (!props.authenticatedUser) {
    const loginToSee = 'Login to see balances';

    return loginToSee;
  }
  return 'No balances';
});
</script>

<template>
  <div class="info-message-block">
    <ot-icon
      :name="authenticatedUser ? 'layer' : 'lock-circle'"
      :inherit-stroke="true"
    />
    <span>
      {{ infoMessage }}
    </span>
  </div>
</template>

<style lang="scss">
.info-message-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 34px 0;
  color: rgb(var(--v-theme-text-secondary));
  font-size: var(--font-size-xs);
  gap: 4px;

  .xs & {
    padding-right: var(--padding-x-xs);
    padding-left: var(--padding-x-xs);
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-medium);
  }
}
</style>
